import { createSelector } from '@reduxjs/toolkit';
import { u as userProfileStoreName } from './baseUserProfile-527bae7d.js';

var profileState = function (state) {
    return state === null || state === void 0 ? void 0 : state[userProfileStoreName];
};
var selectUserPermissions = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.permissions;
});
var selectTopLvlFeatureFlags = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.featureFlags;
});
var selectProfileLoading = createSelector([profileState], function (state) {
    return (state === null || state === void 0 ? void 0 : state.loadingPending) > 0;
});
var selectUserProfileName = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.username;
});
var selectUserProfileId = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.userId;
});
var selectUserProfileType = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.type;
});
var selectUserLanguage = createSelector([profileState], function (state) {
    return state === null || state === void 0 ? void 0 : state.language;
});
// oidc
var selectIdToken = createSelector([profileState], function (_a) {
    var oidc = _a.oidc;
    return oidc.idToken;
});
var selectAccessToken = createSelector([profileState], function (_a) {
    var oidc = _a.oidc;
    return oidc === null || oidc === void 0 ? void 0 : oidc.accessToken;
});
var selectOidcUserLogged = createSelector([profileState], function (_a) {
    var oidc = _a.oidc;
    return oidc === null || oidc === void 0 ? void 0 : oidc.user;
});
var selectIsUserLogged = createSelector([profileState], function (_a) {
    var oidc = _a.oidc;
    return !!(oidc === null || oidc === void 0 ? void 0 : oidc.user);
});
var selectIsUserLoading = createSelector([profileState], function (_a) {
    var oidc = _a.oidc;
    return !!(oidc === null || oidc === void 0 ? void 0 : oidc.isLoadingUser);
});

export { selectTopLvlFeatureFlags as a, selectProfileLoading as b, selectUserProfileName as c, selectUserProfileId as d, selectUserProfileType as e, selectUserLanguage as f, selectIdToken as g, selectAccessToken as h, selectOidcUserLogged as i, selectIsUserLogged as j, selectIsUserLoading as k, selectUserPermissions as s };
